module.exports = new __parcel__URL__("forms-preview.5e482c7a.svg").toString();